import axios from "axios";
import { refreshToken } from "../hooks/tokenUtils";
import { getUserCookie } from "../context/cookieUtils";

// Instancia personalizada de Axios
const baseURL =
  process.env.NODE_ENV === "production"
    ? process.env.REACT_APP_BASE_URL_PROD
    : process.env.REACT_APP_BASE_URL_DEV;

const customFetch = axios.create({
  baseURL: baseURL,
  withCredentials: true,
});

// Interceptor de requests: agrega el token si existe
customFetch.interceptors.request.use(
  async (config) => {
    if (config.data instanceof FormData) {
      delete config.headers["Content-type"];
      delete config.headers["content-type"];
    } else if (!config.headers["Content-type"] && !config.headers["content-type"]) {
      config.headers["Content-type"] = "application/json";
    }

    const user = getUserCookie();
    const token = user?.access;
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    try {
      const fullUrl = (config.baseURL || "") + (config.url || "");
      // eslint-disable-next-line no-console
      console.debug("[axios] →", config.method?.toUpperCase(), fullUrl, config.params || "");
    } catch (_) {}
    return config;
  },
  (error) => Promise.reject(error)
);


// Interceptor de responses: intenta refrescar el token si es necesario
customFetch.interceptors.response.use(
  (response) => response,
  async function (error) {
    // eslint-disable-next-line no-console
    console.error("[axios] ✖", error?.config?.method?.toUpperCase?.(), (error?.config?.baseURL || "") + (error?.config?.url || ""), error?.response?.status, error);
    const originalRequest = error.config || {};
    const url = String(originalRequest.url || "");
    const isRefresh = url.includes("api/auth/token/refresh/");
    // Si el access expiró y no se ha reintentado
    if (
      error.response &&
      error.response.status === 401 &&
      !originalRequest._retry &&
      !isRefresh
    ) {
      originalRequest._retry = true;
      // Refresca el token
      try {
        const resp = await refreshToken();
        if (resp && resp.access) {
          // El token ya está en la cookie, el request interceptor lo tomará
          return customFetch(originalRequest);
        } else {
          // Si el refresh falla, borra la cookie y redirige a login
          document.cookie = "autenticator_user=; Max-Age=0; path=/";
          // Aquí puedes disparar un estado global de sesión expirada si lo necesitas
          return Promise.reject(error);
        }
      } catch (e) {
        document.cookie = "autenticator_user=; Max-Age=0; path=/";
        window.location.href = "/login";
        return Promise.reject(error);
      }
    }
    return Promise.reject(error);
  }
);

export default customFetch;
